module.exports = __webpack_public_path__ + "329c1d3d64c4bdf0e6e7e08fb10bffe3.svg";